import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { ReportTooltipTemplateContextItem } from '@core/reports-types';
@Component({
  selector: 'reports-tooltip-item',
  styleUrls: ['./report-tooltip-item.component.less'],
  template: `
    @if (item.label) {
      <div class="label">
        @if (item.color) {
          <div class="marker" [style.backgroundColor]="item.color"></div>
        }
        <div class="text">
          {{ item.label }}
        </div>
      </div>
    }
    <div class="value" [class.wrap]="wrapValues()">{{ item.value }}</div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.fadeOut]': 'fadeOut()',
  },
})
export class ReportTooltipItemComponent {
  public readonly fadeOut = input<boolean>();
  public readonly wrapValues = input(false);
  @Input() public item: ReportTooltipTemplateContextItem;
}
